<template>
  <header>
    <div class="top">
      <span class="logo fl">
        <img src="../assets/images/logo.png" alt />
        <!-- <img src="../assets/images/kqLogo.png" alt /> -->
      </span>
      <el-menu
        :default-active="$route.path"
        class="el-menu-demo navList fl"
        mode="horizontal"
        active-text-color="#409EFF"
        text-color="#333333"
        router
        @select="handleSelect"
      >
        <el-menu-item index="/home">学习中心</el-menu-item>
        <el-menu-item index="/practiceList">在线练习</el-menu-item>
        <!-- <el-menu-item index="/examList">在线测试</el-menu-item> -->

        <el-submenu index="4">
          <template slot="title">个人中心</template>
          <el-menu-item index="/registrationManagement">报名管理</el-menu-item>
          <el-menu-item index="/personal">个人信息</el-menu-item>
          <!-- <el-menu-item index="/applyMessage">报名管理</el-menu-item> -->
          <el-menu-item index="/personRecord">培训记录</el-menu-item>
          <el-menu-item index="/examRecord">测试记录</el-menu-item>
          <!-- <el-menu-item index="/personProve">培训证明</el-menu-item> -->
          <el-menu-item index="/approve">实名认证</el-menu-item>
          <el-menu-item index="/personSetting">安全设置</el-menu-item>
        </el-submenu>
        <el-menu-item index="/followingTeachingApplication">继教报名</el-menu-item>
      </el-menu>
      <div class="right fr">
        <!-- <a href="http://bdy.eceyun.net/school/" target="_blank">企业后台</a> -->
        <!-- <router-link to="/manage">企业后台</router-link> -->
        <!-- <i class="notice cur" @click="notice"></i> -->
        <!-- <div class="person cur">
          <img src="../assets/images/person.png" alt />
        </div>-->
        <span>
          欢迎
          <span class="name">{{username}}</span>
        </span>
        <span class="cur" @click="loginOut">退出登录</span>
      </div>
    </div>
  </header>
</template>

<script>
import http from "../api/login";

export default {
  // name: "header",
  data() {
    return {
      username: sessionStorage.getItem("username")
      // activeIndex: "1"
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    notice() {
      this.$router.push({
        path: "/notice"
      });
    },
    loginOut() {
      http
        .logout()
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            sessionStorage.removeItem("tokenId");
            localStorage.clear();
            this.$message.success({
              duration: 1000,
              message: "已退出登录!"
            });
            setTimeout(()=>{
              this.$router.push({
                path: "/login"
              });
            },300);
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(errror => {
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    }
  }
};
</script>

<style scoped lang="less">
header {
  width: 100%;
  height: 60px;
  background: #ffffff;
  color: #333333;
  position: fixed;
  left: 0;
  top: 0;
  box-shadow: 0 0 5px 0 #ccc;
  z-index: 9999;
  .top {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
  }
}
.logo {
  display: inline-block;
  width: 200px;
  height: 100%;
  position: relative;
  img {
    max-width: 90%;
    height: auto;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
.navList {
  line-height: 60px;
  li {
    float: left;
    // padding: 0 20px;
    color: #333333;
    cursor: pointer;
    &.active {
      color: #409eff;
    }
    &.router-link-exact-active {
      color: #409eff;
    }
  }
}
.right {
  line-height: 60px;
  // position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // min-width: 160px;
  .name {
    color: #409eff;
    padding: 0 3px;
    margin-right: 10px;
  }
  .notice {
    display: inline-block;
    width: 28px;
    height: 28px;
    background: url("../assets/images/notice.png") no-repeat center;
    background-size: contain;
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
    // padding: 0 20px;
  }
  .person {
    width: 32px;
    height: 32px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
